import { coreStakeholdersDeleteAsyncSlice } from './delete';
import { coreStakeholdersGetAsyncSlice } from './get';
import { coreStakeholdersPatchAsyncSlice } from './patch';
import { coreStakeholdersPostAsyncSlice } from './post';

export const { requestDeleteCoreStakeholders, resetDeleteCoreStakeholders } =
	coreStakeholdersDeleteAsyncSlice.asyncActionCreators;

export const { requestGetCoreStakeholders, resetGetCoreStakeholders } =
	coreStakeholdersGetAsyncSlice.asyncActionCreators;

export const { requestPatchCoreStakeholders, resetPatchCoreStakeholders } =
	coreStakeholdersPatchAsyncSlice.asyncActionCreators;

export const { requestPostCoreStakeholders, resetPostCoreStakeholders } =
	coreStakeholdersPostAsyncSlice.asyncActionCreators;

export * from './_idMap/actions';
